// extracted by mini-css-extract-plugin
export default {"display":"TSiACe","device":"usanxT","speaker":"qlFOah","phone":"zm9fjW"};